import { Box, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { captalize } from 'utils/captalize'
import { getIcon } from '../get-icon'

interface IBadgeConnector {
  name: string
  index?: number
}

const useStyles = makeStyles(() => ({
  badge: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '2rem',
    border: '1px solid #8C8C93',
    width: '2.5rem',
    height: '2.5rem',
    objectFit: 'cover',
    backgroundColor: '#FFFFFF',
  },
}))

const BadgeConnector: React.FC<IBadgeConnector> = ({ name, index = 0 }) => {
  const classes = useStyles()

  return (
    <Tooltip title={captalize(name)}>
      <Box
        className={classes.badge}
        sx={{ marginLeft: index > 0 ? '-1rem' : 0, zIndex: 100 - index }}
      >
        {getIcon(name)}
      </Box>
    </Tooltip>
  )
}

export default BadgeConnector
